import { ScrollView } from 'react-native'

import { getPreviewCellValue, formatPreviewValue, previewTableStyles } from './constants'
import type { ReportPreview } from './types'

interface PreviewTableProps {
  data: ReportPreview
  variant?: 'inline' | 'modal'
}

const PreviewTable = ({ data, variant = 'inline' }: PreviewTableProps) => {
  const table = (
    <table style={previewTableStyles.table}>
      <thead>
        <tr>
          {data.columns.map((col) => (
            <th key={col} style={previewTableStyles.th}>
              {col}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.rows.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {data.columns.map((col, colIndex) => (
              <td key={`${rowIndex}-${col}`} style={previewTableStyles.td}>
                {formatPreviewValue(getPreviewCellValue(row, col, colIndex))}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  )

  if (variant === 'modal') {
    return (
      <ScrollView horizontal nestedScrollEnabled>
        {table}
      </ScrollView>
    )
  }

  return (
    <div style={previewTableStyles.inlineTableContainer}>
      {table}
    </div>
  )
}

export default PreviewTable
